import useSnackbar from 'hooks/useSnackbar'
import { useMemo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useCreateLiquidityTiersMutation, useGetLiquidityTiersQuery } from 'store/api/merklebaseAPI'
import {
  selectLiquidityTiersData,
  selectLiquidityTiersLoading,
  selectLiquidityTiersFetching,
} from 'store/selectors/liquidityTiers'

export default function useLiquidityTiers() {
  useGetLiquidityTiersQuery()
  const liquidityTiers = useSelector(selectLiquidityTiersData)
  const isLoading = useSelector(selectLiquidityTiersLoading)
  const isFetching = useSelector(selectLiquidityTiersFetching)
  const [createTiers] = useCreateLiquidityTiersMutation()
  const { openSnackbar } = useSnackbar()

  const mappedLiquidityTiers = useMemo(() => {
    if (liquidityTiers?.length === 0) {
      return [
        {
          tier: 1,
          marketVolume: 0,
        },
        {
          tier: 2,
          marketVolume: 0,
        },
        {
          tier: 3,
          marketVolume: 0,
        },
      ]
    } else {
      const liquidityTiersMapped = liquidityTiers.map((lt) => ({
        tier: Number(lt.tier),
        marketVolume: lt.min,
      }))

      return liquidityTiersMapped
    }
  }, [liquidityTiers])

  const create = useCallback(
    async (tiers) => {
      const liquidityTiers = []

      for (let i = 0; i < tiers.length; i++) {
        liquidityTiers.push({
          tier: tiers[i]?.tier,
          min: tiers[i]?.marketVolume,
          max: tiers[i - 1]?.marketVolume || 0,
        })
      }

      await createTiers(liquidityTiers)

      openSnackbar({
        message: 'Liquidity tiers saved successfully',
        variant: 'alert',
        color: 'success',
      })
    },
    [createTiers, openSnackbar]
  )

  return {
    liquidityTiers: mappedLiquidityTiers,
    isLoading: isLoading || isFetching,
    create,
  }
}
